import { useEffect, useState } from 'react'

/** How long the tab must stay hidden before streams stop being received. */
export const PAGE_AWAY_DELAY = 15_000

/** True once the tab has been hidden for a while, outside native picture-in-picture. */
export function usePageAway(delay = PAGE_AWAY_DELAY): boolean {
    const [away, setAway] = useState(false)

    useEffect(() => {
        let timer: ReturnType<typeof setTimeout> | undefined
        const update = () => {
            if (timer) clearTimeout(timer)
            timer = undefined
            if (document.visibilityState !== 'hidden') {
                setAway(false)
                return
            }
            timer = setTimeout(() => setAway(!document.pictureInPictureElement), delay)
        }
        update()
        document.addEventListener('visibilitychange', update)
        return () => {
            if (timer) clearTimeout(timer)
            document.removeEventListener('visibilitychange', update)
        }
    }, [delay])

    return away
}
